import React from "react";
// import logo from './logo.svg';
import Routes from "./routes/Index";

const props = () => <>{Routes}</>;
export default props;
